import { scribeTokens } from '../scribe/tokens';

const { colors, radius, typography } = scribeTokens;

export const payoutDialogSx = {
  '& .MuiDialog-paper': {
    borderRadius: `${radius.panel}px`,
    border: `1px solid ${colors.border}`,
    m: { xs: 1, sm: 3 },
    width: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 48px)' },
    maxHeight: 'calc(100% - 32px)',
  },
  '& .MuiDialogTitle-root': {
    ...typography.heading,
    px: { xs: 2, sm: 3 }, py: 2,
    borderBottom: `1px solid ${colors.border}`,
  },
  '& .MuiDialogContent-root': { px: { xs: 2, sm: 3 }, py: 2.5 },
  '& .MuiDialogTitle-root + .MuiDialogContent-root': { pt: 2.5 },
  '& .MuiDialogActions-root': {
    px: { xs: 2, sm: 3 }, py: 1.5, gap: 1,
    borderTop: `1px solid ${colors.border}`,
    backgroundColor: colors.subtle,
  },
};

export const bankIconSx = {
  width: 36, height: 36, flexShrink: 0,
  display: 'grid', placeItems: 'center',
  borderRadius: `${radius.control}px`,
  bgcolor: colors.brandSoft, color: colors.brandHover,
};

export const bankOptionSx = {
  p: 1.5, gap: 1.5, textAlign: 'left', justifyContent: 'flex-start',
  borderColor: colors.border, color: colors.text,
  '&:hover': { borderColor: colors.brand, bgcolor: colors.brandSoft },
  '&.Mui-focusVisible': { outline: `2px solid ${colors.brand}`, outlineOffset: 2 },
};
